export default {
  header: 'Ungespeicherte Änderungen',
  message: 'Deine Änderungen gehen verloren. Trotzdem verlassen?',
};
